"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    getStyle: function() {
        return getStyle;
    },
    getStyleForShow: function() {
        return getStyleForShow;
    },
    getStyleForWrestler: function() {
        return getStyleForWrestler;
    }
});
const getStyleForWrestler = (item)=>getStyle(item?.brand);
const getStyleForShow = (item)=>{
    const active = item?.brands?.[0] || null;
    return getStyle(active);
};
const getStyle = (item)=>{
    let { color = false, backgroundColor = false } = item;
    if (!color || !backgroundColor) {
        color = item?.brand?.color || item?.brands?.[0]?.color || item?.show?.color || item?.championship?.color || item?.championships?.[0]?.color;
        backgroundColor = item?.brand?.backgroundColor || item?.brands?.[0]?.backgroundColor || item?.show?.backgroundColor || item?.championship?.backgroundColor || item?.championships?.[0]?.backgroundColor;
    }
    return {
        backgroundColor,
        color
    };
};
const _default = getStyle;
